import { Field } from "@comet/admin";
import { Button, Typography } from "@mui/material";
import FileUpload from "@src/components/fields/FileUpload";
import csvToJson from "csvtojson";
import { type FC } from "react";
import { type FieldRenderProps } from "react-final-form";
import { useIntl } from "react-intl";

export interface LicenceInput {
    code: string;
}

export const convertCsvToCodesArray = (file: Blob): Promise<string[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            const fileAsBinaryString = reader.result;

            if (!fileAsBinaryString) reject("file is empty");

            csvToJson({
                output: "csv",
                delimiter: [",", ";"],
            })
                .fromString(fileAsBinaryString as string)
                .then((csvRows) => {
                    const codes = csvRows.map(([code]) => code);

                    resolve(codes);
                });
        };
        reader.onabort = () => reject("file reading was aborted");
        reader.onerror = () => reject("file reading has failed");

        reader.readAsBinaryString(file);
    });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CsvImport: FC<FieldRenderProps<{ file: any }, HTMLInputElement>> = ({ input }) => {
    const intl = useIntl();
    const onDrop = async (acceptedFiles: File[], rejectedFiles: File[]) => {
        acceptedFiles.forEach((file) => {
            if (input.onChange) {
                input.onChange({ file });
            }
        });
    };

    return (
        <>
            <Field name={`${input.name}.file`} component={FileUpload} dropzoneOptions={{ accept: [".csv"], onDrop }} required />
            {input.value.file && (
                <Button onClick={() => input.onChange(null)} variant="text">
                    <Typography>{intl.formatMessage({ id: "removeFile", defaultMessage: "Datei entfernen" })}</Typography>
                </Button>
            )}
        </>
    );
};

export default CsvImport;
